import React from 'react';
import { useBuSettings, useMachineInfo } from 'common/pages/fleetV2/providers';
import { useFleetRouter } from 'common/pages/fleetV2/hooks/useFleetRouter';
import { useGetProsealMachineStatusQuery } from 'common/pages/fleetV2/machine/proseal/api';
import { getUserTimeZone, isUSTimeZone } from 'common/helpers/v1';
import { format } from 'date-fns';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { MachineStatusProps } from '../types';
import { POLLING_INTERVAL } from '../utils';


export const useMachineStatusProseal = (): MachineStatusProps => {

  const { colors, Icons } = useBuSettings();
  const [{ id: machineId }] = useFleetRouter();
  const { timeZone } = useMachineInfo() as { timeZone: string };

  const { data, isLoading, hasError } = useGetProsealMachineStatusQuery({
    machineId: machineId as string,
  }, { pollingInterval: POLLING_INTERVAL }) as  {
    data : {
      connectionStatus?: string;
      latestDataReceived?: string;
    },
    isLoading: boolean; 
    hasError?: string;
  };

  const isUSA = isUSTimeZone(getUserTimeZone()); //Affects time formatting AM/PM vs 14:00
  const formattedDate = data?.latestDataReceived && utcToZonedTime(data?.latestDataReceived?.slice(0, 19) + '+00:00', timeZone);

  const time = data?.connectionStatus?.toLowerCase() === 'online' ? undefined : formattedDate && data?.latestDataReceived && (isUSA ? format(new Date(formattedDate), 'MM/dd/yyyy h:mm a') : format(new Date(formattedDate), 'dd/MM/yyyy HH:mm'))

  return {
    color: data?.connectionStatus?.toLowerCase() === 'online' ? colors?.['connected'] : colors?.['disconnected'],
    status: data?.connectionStatus?.toLowerCase() === 'online' ? 'Connected' : 'Not Connected',
    Icon: data?.connectionStatus?.toLowerCase() === 'online' ? Icons?.['connected'] : Icons?.['disconnected'],
    timestamp: time,
    isLoading, 
    hasError
  };
};